import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  & > span {
    font-size: 14px;
    color: #888;
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 5px 0px 0px 5px;
    border-right: none;
    margin-right: -5px;
    background: #eee;
    height: 43px
  }
  & > input {
    border-radius: 0px 5px 5px 0px;
    border-left: none;
    padding: 8px;
    padding-left: 5px;
    border: 1px solid #ccc;
    height: 43px;

    & :focus,
    :hover {
      border: ${({ theme }) => `1px solid ${theme.palette.primary.main}`};
    }
  }
`;

export const Link = styled.a`
  font-size: 12px;
  color: inherit;
`;

export const Actions = styled.div`
  position: absolute;
  right: 5px;
  top: -30px;
  color: ${({ theme }) => theme.palette.primary.main};
  & > * {
    margin-left: 10px;
  }
`;
